<div class="min-h-lvh relative">
  <div class="auth-bg-image"></div>

  <div class="min-h-lvh flex items-center justify-center overflow-hidden">
    <div class="flex rounded-[1.25rem] bg-white relative w-[55.875rem] h-[40.75rem] shadow-3xl mx-10 my-[6.25rem]">
      <div class="w-[21.75rem] flex py-3 pl-3">
        <div
          class="auth-about-panel flex flex-col flex-1 rounded-xl bg-[url('/assets/img/auth-container-bg.svg')] bg-secondary bg-[length:15.8125rem_22.625rem] bg-no-repeat bg-[right_bottom_0.9375rem]"
        >
          <a routerLink="/"><div class="ml-10 mt-[3.75rem] bg-no-repeat bg-rocketkor-logo-admin w-[16.125rem] h-[3.875rem]"></div></a>

          <div class="auth-about-copy flex flex-1 justify-center flex-col font-bold text-2xl text-white ml-10 pr-6 mb-20">
            <div class="font-extrabold">KOR</div>
            <span class="mt-4 block italic font-normal">noun</span>
            the central, innermost, or&nbsp;most essential part of&nbsp;anything.
            <span class="mt-4 block italic font-normal">adjective</span>
            of central importance; basic; fundamental
          </div>
        </div>
      </div>

      <div class="flex flex-col flex-1 pt-[6.75rem] px-[3.75rem] pb-10">
        <div class="flex-1">
          <ng-content></ng-content>
        </div>

        <app-version class="pt-6 text-xs text-font-tertiary" />
      </div>
    </div>
  </div>
</div>
